import { render, staticRenderFns } from "./FriendManagementGroupManagement.vue?vue&type=template&id=106e4504"
import script from "./FriendManagementGroupManagement.vue?vue&type=script&lang=ts"
export * from "./FriendManagementGroupManagement.vue?vue&type=script&lang=ts"
import style0 from "./FriendManagementGroupManagement.vue?vue&type=style&index=0&id=106e4504&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports